export default __webpack_public_path__ + "static/media/about-icon.ca6ebe8a.gif";